export default "__VITE_ASSET__vR7DhQZ9__"